import { createContext, useContext } from 'react';
import { AiBudgetBlockedReasonEnum } from 'graphql-common';
import { AiCredits } from 'components/AiAssistant/AiCreditsIndicator';

export type AiBudgetValue = {
  // Remaining/total display credits, or null when AI is disabled, the query is
  // still loading, or no cap is configured (unlimited usage → nothing to show).
  credits: AiCredits | null;
  // Why AI spend is refused right now, or null while it is admitted. The only
  // correct signal for "can the user use AI" (BE guide §10) — never derive it
  // from `credits`.
  blockedReason: AiBudgetBlockedReasonEnum | null;
  // Re-pull the budget after a credit-consuming action (a field generation or a
  // chat message).
  refetch: () => void;
};

const AiBudgetContext = createContext<AiBudgetValue | null>(null);

export const AiBudgetContextProvider = AiBudgetContext.Provider;

// Null outside a provider — `useAiBudgetStatus` then falls back to its own
// query, so a surface rendered on its own (a unit test, a future non-dashboard
// mount) still works, just without the shared cache.
export const useSharedAiBudget = () => useContext(AiBudgetContext);
